import { VggishEmbeddingResult } from '@videoblocks/ml-text-service-client';

import { embeddingsApi } from './mlTextServiceConfig';

export const getEmbeddingFromAudio = async (file: File): Promise<VggishEmbeddingResult> => {
    const result = await embeddingsApi.embeddingsVggishPost({ file });

    return result.data.results;
};
